import {SpeciesCreate, SpeciesEdit, SpeciesList} from '@/admin/resources/species/Species';

export default {
  list: SpeciesList,
  edit: SpeciesEdit,
  create: SpeciesCreate,
};
